<template>
  <div
    class="icon-selector-business-size"
    :class="`theme-${props.theme}`"
    data-private-info="true"
  >
    <SvgIcon
      name="business_small"
      :class="{ active: modelValue < midInterval(props.min, props.max) }"
      @click="updateValue(props.min)"
    />
    <SvgIcon
      name="business_large"
      :class="{ active: modelValue >= midInterval(props.min, props.max) }"
      @click="updateValue(props.max)"
      style="width: 60px; height: 32px"
    />
  </div>
</template>

<script setup lang="ts">
import './IconSelectorBusinessSize.scss';
import SvgIcon from 'ewi-ui/components/1-atoms/Icon/SvgIcon/SvgIcon.vue';

interface Props {
  modelValue: number;
  min: number;
  max: number;
  theme?: string;
}

const props = withDefaults(defineProps<Props>(), {
  theme: '',
});

const emit = defineEmits<{
  (e: 'update:modelValue', value: number): void;
}>();

const midInterval = (min: number, max: number): number => {
  return (max - min) / 2 + min;
};

const updateValue = (value: number): void => {
  emit('update:modelValue', value);
};
</script>
